import { Col, Form, Input, message, Modal, Row, Select } from "antd";
import { Rule } from "antd/lib/form";
import { roleApi } from "api/role.api";
import { staffApi } from "api/staff.api";
import { SingleImageUpload } from "components/Upload/SingleImageUpload";
import React, { useEffect, useState } from "react";
import { ModalStatus } from "types/modal";
import { Role } from "types/role";
import { Staff } from "types/staff";

const rules: Rule[] = [{ required: true }];
const { Option } = Select;

interface StaffForm extends Staff {
  roleId?: number;
}

export const StaffModal = ({
  visible,
  status,
  staff,
  onClose,
  onSubmitOk,
}: {
  visible: boolean;
  status: ModalStatus;
  staff: Partial<Staff>;
  onClose: () => void;
  onSubmitOk: () => void;
}) => {
  const [form] = Form.useForm<StaffForm>();
  const [loading, setLoading] = useState(false);
  const [roles, setRoles] = useState<Role[]>([]);

  useEffect(() => {
    if (status == "create" && visible) {
      form.resetFields();
    }
  }, [visible, status]);

  useEffect(() => {
    fetchRole();
  }, []);

  const fetchRole = async () => {
    const res = await roleApi.findAll({ page: 1, limit: 0 });
    setRoles(res.data);
  };

  useEffect(() => {
    form.setFieldsValue({
      ...staff,
      roleId: staff.role?.id,
    });
    return () => {};
  }, [staff]);

  const createData = async () => {
    const valid = await form.validateFields();
    const data = {
      staff: form.getFieldsValue(),
      roleId: form.getFieldValue("roleId"),
    };

    setLoading(true);
    try {
      const res = await staffApi.create(data);
      message.success("Tạo mới thành công!");
      onClose();
      onSubmitOk();
    } finally {
      setLoading(false);
    }
  };

  const updateData = async () => {
    const valid = await form.validateFields();
    const data = {
      staff: form.getFieldsValue(),
      roleId: form.getFieldValue("roleId"),
    };
    setLoading(true);
    try {
      const res = await staffApi.update(staff?.id || 0, data);
      message.success("Cập nhật thành công!");
      onClose();
      onSubmitOk();
    } finally {
      setLoading(false);
    }
  };

  return (
    (<Modal
      onCancel={onClose}
      open={visible}
      title={status == "create" ? "Tạo mới nhân viên" : "Cập nhật nhân viên"}
      style={{ top: 20 }}
      width={700}
      cancelText="Đóng"
      confirmLoading={loading}
      onOk={() => {
        status == "create" ? createData() : updateData();
      }}
    >
      <Form layout="vertical" form={form}>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item label="Username" name="username" rules={rules}>
              <Input disabled={status == "update"} placeholder="" />
            </Form.Item>
          </Col>

          {status == "create" && (
            <Col span={12}>
              <Form.Item label="Mật khẩu" name="password" rules={rules}>
                <Input placeholder="" />
              </Form.Item>
            </Col>
          )}

          <Col span={12}>
            <Form.Item label="Họ tên" name="name" rules={rules}>
              <Input placeholder="" />
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item label="Số điện thoại" name="phone" rules={rules}>
              <Input placeholder="" />
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item label="Email" name="email">
              <Input placeholder="" />
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item label="Quyền" name="roleId" rules={rules}>
              <Select style={{ width: "100%" }}>
                {roles.map((role) => (
                  <Option key={role.id} value={role.id}>
                    {role.name}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>

        <Form.Item shouldUpdate={true}>
          {() => {
            return (
              <Form.Item label="Avatar" name="avatar">
                <SingleImageUpload
                  onUploadOk={(path: string) => {
                    console.log("onUploadOk:", path);
                    form.setFieldsValue({
                      avatar: path,
                    });
                  }}
                  imageUrl={form.getFieldValue("avatar")}
                />
              </Form.Item>
            );
          }}
        </Form.Item>
      </Form>
    </Modal>)
  );
};
